// extracted by mini-css-extract-plugin
export default {"search_area":"SearchArea_search_area__IYtms","search_area__input":"SearchArea_search_area__input__DHn8w"};